import PropTypes from 'prop-types';
import styled from 'styled-components';
import type { LeftProps, RightProps } from 'styled-system';
import { left, right } from 'styled-system';

import type { CommonProps, LayoutProps } from './constants';
import { COMMON, LAYOUT } from './constants';
import type { Theme } from './theme';
import theme from './theme';

type Props = CommonProps;

const Dropdown = styled.div<Props>`
  position: relative;
  ${COMMON};
`;

Dropdown.defaultProps = { theme };

Dropdown.propTypes = {
  ...COMMON.propTypes,
  theme: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

type MenuProps = CommonProps & LayoutProps & LeftProps<Theme> & RightProps<Theme>;

const Menu = styled.ul<MenuProps>`
  position: absolute;
  top: 100%;
  z-index: ${theme.zIndices.dropdown};
  ${left}
  ${right}
  ${COMMON};
  ${LAYOUT};
`;

Menu.defaultProps = { theme };

Menu.propTypes = {
  ...COMMON.propTypes,
  ...LAYOUT.propTypes,
  theme: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

Dropdown.displayName = 'Dropdown';
Menu.displayName = 'Dropdown.Menu';

(Dropdown as any).Menu = Menu;
const FullDropdown: typeof Dropdown & { Menu: typeof Menu } = Dropdown as any;

export { FullDropdown as Dropdown };
